import { Device } from '@capacitor/device'

export default async (context, inject) => {
  const deviceInfo = await Device.getInfo()
  inject('deviceType', () => deviceInfo.platform)
}
